import { useState } from "react";
import { Ticket } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const RedeemCode = ({ onRedeemed }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const redeem = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/billing/redeem", { code });
      toast.success(`Code applied — ${data.days_added} days of free access added!`);
      setCode("");
      onRedeemed(data);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={redeem} className="surface p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="redeem-code-form">
      <div className="flex items-center gap-2 text-sm font-semibold sm:w-56 shrink-0"><Ticket className="h-5 w-5 text-amber-500" /> Have a promo code?</div>
      <Input data-testid="redeem-code-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="e.g. LAWN60" className="font-mono uppercase flex-1" maxLength={32} />
      <Button data-testid="redeem-code-button" type="submit" disabled={busy || !code.trim()} variant="outline" className="font-bold">{busy ? "Applying..." : "Apply code"}</Button>
    </form>
  );
};
